import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="flip-card"
export default class extends Controller {
  static targets = [
    'flipCardInner',
  ]

  static values = {
    autoFlip: Boolean,
  }

  declare readonly flipCardInnerTarget: HTMLElement
  declare autoFlipValue: boolean

  connect (): void {
    if (this.autoFlipValue) {
      this.flip()
    }
  }

  flip (): void {
    const classes = [...this.flipCardInnerTarget.classList]
    if (classes.includes('rotate-y-180')) {
      this.flipCardInnerTarget.classList.remove('rotate-y-180')
    } else {
      this.flipCardInnerTarget.classList.add('rotate-y-180')
    }
  }

  pickup (): void {
    this.element.classList.add('-translate-y-1', 'shadow-xl', 'cursor-pointer')
  }

  putdown (): void {
    this.element.classList.remove('-translate-y-1', 'shadow-xl', 'cursor-pointer')
  }
}
